import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import filter from '../../versa/filter.js';
import router from '../../versa/router.js';
import formset from '../../versa/formset.js';
import record from '../../versa/record.js';
import { notify, ask } from '../../versa/msgbox.js';
import pdf from '../../versa/pdf.js';
import view from '../views/inventories.js';
import form from '../forms/inventories.js';
import create_inventory_form from '../forms/inventories-create-inventory.js';
import check_inventory_form from '../forms/inventories-check-inventory.js';
import * as types from '../types.js';

const inventories = function()
{

	let inventories_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_warehouses, this.queryAll()).then((data) => db.set('warehouses', data).catch(error => notify(error)));
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data).catch(error => notify(error)));
			api.call(api.list_lots, this.queryAll()).then((data) => db.set('lots', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_inventories, query);
		},
		insertRecord()
		{
			this.createInventory();
		},
		async editFilter() {
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data) {
			this.filter = data;
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			this.loadPage(1);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_inventory, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name
			};
			if (old_data)
				return await api.call(api.update_inventory, data.company_id, data.warehouse_id, data.id, _record);
			else
				return await api.call(api.insert_inventory, data.company_id, data.warehouse_id, _record);
		},
		createInventory()
		{
			const showResult = (resp) =>
			{
				this.loadPage();	// Required to show new record
				fs.destroy();
			}
			const sendRequest = async (data) =>
			{
				let record = {
					name: data.name
				}
				let resp = await api.call(api.insert_inventory, data.company_id, data.warehouse_id, record).then(showResult);
			}
			let fs = formset.create(create_inventory_form, sendRequest);
			fs.init();
		},
		async checkInventory()
		{
			const sendRequest = async (data) =>
			{
				let record = {
					location_id: data.location_id,
					lot_company_id: data.lot_company_id,
					lot_id: data.lot_id,
					quantity: Number(data.quantity)
				};
				return await api.call(api.check_inventory_item, data.company_id, data.warehouse_id, data.inventory_id, record);
			}
			let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id'])
			if (ids.length != 1)
				return notify('Selecione um inventário', 'Conferência Manual');
			record.edit(check_inventory_form, sendRequest, { 'company_id': ids[0][0], 'warehouse_id': ids[0][1], 'inventory_id': ids[0][2] });
		},
		async cancelInventory()
		{
			const showResult = (resp) =>
			{
				this.loadPage();	// Required to show the closing date/time
			}
			const sendRequest = async (company_id, warehouse_id, inventory_id) =>
			{
				let resp = await api.call(api.cancel_inventory, company_id, warehouse_id, inventory_id).then(showResult);
			}
			let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id'])
			if (ids.length != 1)
				return notify('Selecione um inventário para cancelar', 'Cancelar Inventário');
			ask(`Cancelar inventário selecionado?`, 'Confirmação', (answer) =>
			{
				if (answer == 'Y')
					sendRequest(ids[0][0], ids[0][1], ids[0][2]);
			});
		},
		async closeInventory()
		{
			const showResult = (resp) =>
			{
				this.loadPage();	// Required to show the closing date/time
			}
			const sendRequest = async (company_id, warehouse_id, inventory_id) =>
			{
				let resp = await api.call(api.close_inventory, company_id, warehouse_id, inventory_id).then(showResult);
			}
			let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id'])
			if (ids.length != 1)
				return notify('Selecione um inventário para encerrar', 'Encerrar Inventário');
			ask(`Encerrar inventário selecionado?`, 'Confirmação', (answer) =>
			{
				if (answer == 'Y')
					sendRequest(ids[0][0], ids[0][1], ids[0][2]);
			});
		},
		async printPending()
		{
			const showResult = async (resp) =>
			{
				this.clearGridSelection();
				if (resp?.pdf)
					pdf(resp.pdf);
			}
			const sendRequest = async (company_id, warehouse_id, inventory_id) =>
			{
				let resp = await api.call(api.print_inventory_pending, company_id, warehouse_id, inventory_id).then(showResult);
			}
			let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id'])
			if (ids.length != 1)
				return notify('Selecione um inventário para imprimir', 'Relatório de Pendências');
			sendRequest(ids[0][0], ids[0][1], ids[0][2]);
		},
		async printDeviation()
		{
			const showResult = async (resp) =>
			{
				this.clearGridSelection();
				if (resp?.pdf)
					pdf(resp.pdf);
			}
			const sendRequest = async (company_id, warehouse_id, inventory_id) =>
			{
				let resp = await api.call(api.print_inventory_deviation, company_id, warehouse_id, inventory_id).then(showResult);
			}
			let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id'])
			if (ids.length != 1)
				return notify('Selecione um inventário para imprimir', 'Relatório de Divergências');
			sendRequest(ids[0][0], ids[0][1], ids[0][2]);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'warehouse_id', label: 'Armazém', types: [types.datalist()], placeholder: '', title: 'Armazém do estoque', store: 'warehouses', labels: ['name'] },
		{ index: 4, field: 'started_on', label: 'Início', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de início do inventário' },
		{ index: 5, field: 'completed_on', label: 'Conclusão', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de conclusão do inventário' },
		{ index: 6, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome do inventário' },
		{ index: 7, field: 'status', label: 'Status', types: [types.opt_inventory_status(), types.datalist()], placeholder: '', title: 'Status do inventário' },
	];

	let operations = [
		{ hash: '#check-inventory',		label: 'Conferência&nbsp;Manual'	},
		{ hash: '#cancel-inventory',	label: 'Cancelar&nbsp;Inventário'	},
		{ hash: '#close-inventory',		label: 'Encerrar&nbsp;Inventário'	},
	];

	let reports = [
		{ hash: '#print-pending', 	label: 'Relatório&nbsp;de&nbsp;Pendências' },
		{ hash: '#print-deviation',	label: 'Relatório&nbsp;de&nbsp;Divergências' },
	];

	router.set('#check-inventory', inventories_crud.checkInventory.bind(inventories_crud));
	router.set('#cancel-inventory', inventories_crud.cancelInventory.bind(inventories_crud));
	router.set('#close-inventory', inventories_crud.closeInventory.bind(inventories_crud));
	router.set('#print-pending', inventories_crud.printPending.bind(inventories_crud));
	router.set('#print-deviation', inventories_crud.printDeviation.bind(inventories_crud));

	inventories_crud.run(
		'inventories',
		'Inventários',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		reports
	);

};

export default inventories;

